import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  DomSanitizer,
  Meta,
  SafeResourceUrl,
  Title,
} from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';

import {
  IStrapiDocuments,
  ProtectAndSaveProduct,
} from 'src/app/interfaces/strapi';

import { UserService } from 'src/app/services/user.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { TabData, GenericTabsComponent } from '../generic-tabs/generic-tabs.component';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-protect-and-save-product-component',
    templateUrl: './protect-and-save-product-component.component.html',
    styleUrls: ['./protect-and-save-product-component.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgIf,
        RouterLink,
        GenericTabsComponent,
        RenderMarkdownComponent,
    ],
})
export class ProtectAndSaveProductComponentComponent
  extends PageComponent
  implements OnInit
{
  public override pageData: ProtectAndSaveProduct = <ProtectAndSaveProduct>{};

  public tabData: TabData[] = [];

  public tabContent: string = '';

  public productRetrievalError = false;

  constructor(
    protected override readonly titleService: Title,
    protected override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly userService: UserService,
    private readonly route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit() {
    // First get the product id from the current route.
    const routeParams = this.route.snapshot.paramMap;
    const productUID = String(routeParams.get('productUID'));

    if (productUID) {
      this.strapi.getProtectAndSaveProducts().subscribe({
        next: (data: IStrapiDocuments<ProtectAndSaveProduct>) => {
          const product = data.data.find(
            (item) => item.attributes.uid === productUID
          );

          this.parsePageData(product!.attributes);
          super.setMetas();

          this.pageData.tabs.forEach((tab, index) => {
            this.tabData[index] = {
              title: tab.title,
              id: index.toString(),
              isActive: index === 0,
            };
          });

          // Run function with initial selected tab
          this.onTabChanged('0');
          this.cdr.markForCheck();
        },
        error: () => {
          this.productRetrievalError = true;
        },
        complete: () => {
          this.cdr.markForCheck();
        }
      });
    }
  }

  protected override parsePageData(page: ProtectAndSaveProduct): void {
    super.parsePageData(page);

    this.pageData = page;
  }

  public youtubeUrl(): SafeResourceUrl {
    const videoId = String(this.pageData.video_id);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}`
    );
  }

  public onTabChanged(id: string): void {
    this.tabContent = this.pageData.tabs[+id].content;
  }
}
